import React, { useState, useEffect } from 'react';

type VisualViewportMetrics = {
  height: number;
  offsetTop: number;
};

export const useVisualViewportMetrics = (): VisualViewportMetrics => {
  const [metrics, setMetrics] = useState<VisualViewportMetrics>(() => {
    if (typeof window === 'undefined') {
      return { height: 0, offsetTop: 0 };
    }

    return {
      height: window.visualViewport?.height || window.innerHeight,
      offsetTop: window.visualViewport?.offsetTop || 0,
    };
  });

  useEffect(() => {
    const updateViewportMetrics = (): void => {
      setMetrics({
        height: window.visualViewport?.height || window.innerHeight,
        offsetTop: window.visualViewport?.offsetTop || 0,
      });
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportMetrics);
      window.visualViewport.addEventListener('scroll', updateViewportMetrics);

      return (): void => {
        window.visualViewport?.removeEventListener(
          'resize',
          updateViewportMetrics
        );
        window.visualViewport?.removeEventListener(
          'scroll',
          updateViewportMetrics
        );
      };
    }

    window.addEventListener('resize', updateViewportMetrics);
    window.addEventListener('orientationchange', updateViewportMetrics);

    return (): void => {
      window.removeEventListener('resize', updateViewportMetrics);
      window.removeEventListener('orientationchange', updateViewportMetrics);
    };
  }, []);

  return metrics;
};

export const useDynamicViewport = (): number => {
  const [viewportHeight, setViewportHeight] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.visualViewport?.height || window.innerHeight;
    }
    return 0;
  });

  useEffect(() => {
    const updateViewportHeight = (): void => {
      const height = window.visualViewport?.height || window.innerHeight;
      setViewportHeight(height);
    };

    // visualViewport é mais preciso para detectar mudanças da barra de endereço
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportHeight);
      window.visualViewport.addEventListener('scroll', updateViewportHeight);

      return (): void => {
        window.visualViewport?.removeEventListener(
          'resize',
          updateViewportHeight
        );
        window.visualViewport?.removeEventListener(
          'scroll',
          updateViewportHeight
        );
      };
    }

    // Fallback para navegadores que não suportam visualViewport
    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', updateViewportHeight);

    return (): void => {
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, []);

  return viewportHeight;
};
